module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.84cf469.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/self-diagnosis/font/notokr-bold.woff
// module id = q6j5
// module chunks = 0